module.exports = __webpack_public_path__ + "img/b774537d4652d51b5658db879d569c28.png";